import { render } from "./DashboardRanking.vue?vue&type=template&id=876493ae&scoped=true"
import script from "./DashboardRanking.vue?vue&type=script&lang=js"
export * from "./DashboardRanking.vue?vue&type=script&lang=js"

import "./DashboardRanking.vue?vue&type=style&index=0&id=876493ae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-876493ae"]])

export default __exports__